import React, { useState } from 'react';
import { AlarmClock, ChevronDown, ChevronUp, X } from 'lucide-react';
import { formatWhen } from '@/components/ai/RemindMenu';

// Upcoming reminders at the bottom of the chat sidebar.
export const RemindersPanel = ({ reminders, onCancel, onOpenChat }) => {
  const [open, setOpen] = useState(true);
  return (
    <div className="reminders-panel" data-testid="reminders-panel">
      <button type="button" className="reminders-head" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid="reminders-toggle">
        <AlarmClock size={14} /> <span>Reminders</span>
        <span className="reminders-count" data-testid="reminders-count">{reminders.length}</span>
        {open ? <ChevronDown size={14} /> : <ChevronUp size={14} />}
      </button>
      {open && (
        <div className="reminders-list">
          {!reminders.length && <p className="reminders-empty" data-testid="reminders-empty">None yet — use “Remind me” under any answer.</p>}
          {reminders.map((r) => (
            <div key={r.id} className="reminder-item" data-testid={`reminder-${r.id}`}>
              <button type="button" className="reminder-main" onClick={() => r.chat_id && onOpenChat?.(r.chat_id)} title={r.text} data-testid={`reminder-open-${r.id}`}>
                <span className="reminder-when">{formatWhen(new Date(r.due_at))}</span>
                <span className="reminder-text">{r.text}</span>
              </button>
              <button type="button" className="reminder-cancel" onClick={() => onCancel(r.id)} aria-label="Cancel reminder" data-testid={`reminder-cancel-${r.id}`}>
                <X size={13} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
